import { convertStringToBoolean } from '../helpers/utils';

export const prepareSubscriptionRequest = data => {
  const {
    categoryId,
    locationIds = [],
    lotState = null,
    lotType = null,
    productType = null,
    query = null,
    searchInDescription,
    tagIds,
  } = data;

  return {
    categoryId: Number(categoryId) ? parseInt(categoryId, 10) : null,
    locationIds: locationIds.map(location => parseInt(location, 10)),
    lotType: lotType !== 'all' ? lotType : null,
    productType: productType !== 'all' ? productType : null,
    searchInDescription: searchInDescription && query ? convertStringToBoolean(searchInDescription) : null,
    tagIds: tagIds ? [parseInt(tagIds, 10)] : null,
    lotState,
    query,
  };
};
